'use strict';
import Gauge from 'svg-gauge';

const $ = window.jQuery;

export default function () {

    let gaugesCard = document.querySelectorAll('.join-us__cards-gauge__card');
    gaugesCard.forEach(card => {
        let mainGauge = card.querySelector(".main-gauge");

        if (isInViewport(mainGauge) && !mainGauge.classList.contains("lauched")) {
            setGauge(mainGauge, "main");
            mainGauge.classList.add("lauched");
        }


        let secondaryGauge = card.querySelector(".secondary-gauge");
        if (isInViewport(secondaryGauge) && !secondaryGauge.classList.contains("lauched")) {
            setGauge(secondaryGauge, "secondary");
            secondaryGauge.classList.add("lauched");
        }
    });

    $(window).scroll(function () {
        let gaugesCard = document.querySelectorAll('.join-us__cards-gauge__card');
        gaugesCard.forEach(card => {
            let mainGauge = card.querySelector(".main-gauge");

            if (isInViewport(mainGauge) && !mainGauge.classList.contains("lauched")) {
                setGauge(mainGauge, "main");
                mainGauge.classList.add("lauched");
            }


            let secondaryGauge = card.querySelector(".secondary-gauge");
            if (isInViewport(secondaryGauge) && !secondaryGauge.classList.contains("lauched")) {
                setGauge(secondaryGauge, "secondary");
                secondaryGauge.classList.add("lauched");
            }
        });
    });






};

function setGauge(gauge, type) {
    if (type == "main") {

        let target = gauge.getAttribute("data-value");
        var gauge3 = Gauge(
            gauge, {
            max: 100,
            dialStartAngle: 150,
            dialEndAngle: 30,
            value: 0
        }
        );

        gauge3.setValueAnimated(target, 2);
    }
    if (type == "secondary") {
        let target = gauge.getAttribute("data-value");
        var gauge3 = Gauge(
            gauge, {
            max: 100,
            dialStartAngle: 150,
            dialEndAngle: 30,
            value: 0
        }
        );

        gauge3.setValueAnimated(target, 2);
    }

}

function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}
